import { useIsRTL } from '../../locale';
import { getContainerOffset } from './__internal__/getContainerOffset';
import { elementIsFullyVisible, elementLeftIsClipped, elementRightIsClipped, moveFocus, scrollHorizontal } from './horizontalScroll';
import { elementBottomIsClipped, elementTopIsClipped, scrollVertical } from './verticalScroll';

/**
 * Returns API which can be used for horizontal or vertical scrolling
 * @param containerRef - reference for the containing DOM element which needs to be scrolled
 * @param orientation - orientation of the component.
 * @param contentsRef - optional. Array of references
 *
 */

export function useScroll(containerRef,
// Element for which scrollLeft needs to be updated
orientation, contentsRef, includeOffset, parentContainerRef) {
  const isRTL = useIsRTL();
  const offset = includeOffset ? getContainerOffset(parentContainerRef?.current ?? null) : {
    offsetLeft: 0,
    offsetRight: 0
  };
  if (!orientation || orientation === 'horizontal') {
    return {
      scrollToPrevious: () => moveFocus('back', containerRef, contentsRef, isRTL),
      scrollToNext: () => moveFocus('next', containerRef, contentsRef, isRTL),
      scrollTo: (item, scrollTo) => {
        const container = containerRef.current;
        if (!container) return;
        scrollHorizontal(container, item.getBoundingClientRect(), scrollTo);
      },
      elementIsFullyVisible: element => {
        const container = containerRef.current;
        if (!container) return false;
        return elementIsFullyVisible(container, element, offset);
      },
      elementBackIsClipped: element => {
        const container = containerRef.current;
        if (!container) return false;
        return isRTL ? elementRightIsClipped(container, element, offset.offsetRight) : elementLeftIsClipped(container, element, offset.offsetLeft);
      },
      elementNextIsClipped: element => {
        const container = containerRef.current;
        if (!container) return false;
        return isRTL ? elementLeftIsClipped(container, element, offset.offsetLeft) : elementRightIsClipped(container, element, offset.offsetRight);
      }
    };
  }
  return {
    scrollTo: (item, scrollTo) => {
      const container = containerRef.current;
      if (!container) return;
      scrollVertical(container, item.getBoundingClientRect(), scrollTo);
    },
    elementIsFullyVisible: element => {
      const container = containerRef.current;
      if (!container) return false;
      return !elementTopIsClipped(container, element) && !elementBottomIsClipped(container, element);
    },
    elementBackIsClipped: element => {
      const container = containerRef.current;
      if (!container) return false;
      return elementTopIsClipped(container, element);
    },
    elementNextIsClipped: element => {
      const container = containerRef.current;
      if (!container) return false;
      return elementBottomIsClipped(container, element);
    }
  };
}
//# sourceMappingURL=useScroll.js.map